import { render, staticRenderFns } from "./advancepayments.vue?vue&type=template&id=951ead52&scoped=true&"
import script from "./advancepayments.vue?vue&type=script&lang=js&"
export * from "./advancepayments.vue?vue&type=script&lang=js&"
import style0 from "./advancepayments.vue?vue&type=style&index=0&id=951ead52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951ead52",
  null
  
)

export default component.exports